import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { Heading, Container, Text } from "@chakra-ui/react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const Bikefinder = ({ data, location }) => {
  return (
    <Layout location={location} container>
      <SEO title="Bikefinder" />
      <Container marginTop="20">
        <Heading size="xl" marginBottom="5">
          Bikefinder
        </Heading>
        <Img fluid={data.bikefinder?.childImageSharp.fluid} alt="" />
        <Text>
          Bikefinder er inkludert i månedspris når man velger å lease sykkel.
          Vår leasingpartner krever at sykkel er forsikret i hele
          leasingperioden og da er Bikefinder + forsikring den rimeligste og
          beste forsikringsløsningen. Ved kjøp av sykkel kan man valgfritt velge
          om Bikefinder + forsikring skal være med. Bikefinder ligger som eget
          produkt i varelisten.
        </Text>
      </Container>
    </Layout>
  )
}

Bikefinder.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default Bikefinder

export const query = graphql`
  query {
    bikefinder: file(relativePath: { eq: "bikefinder.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`
